import { useContext } from "react";
import { ActiveConvenioContext } from ".";

export const useActiveConvenio = () => useContext(ActiveConvenioContext);
